import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemText,
    CircularProgress,
    Paper,
    Dialog,
    DialogTitle,
    DialogActions
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { getBookingStatusClass, SERVER_URL } from '../../utils/config/constants.js';
import { KeyboardArrowDown, FilterList } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton.js';
import {
    BOOKING_VIEW_ALL,
    BOOKING_VIEW_INPROGRESS,
    BOOKING_VIEW_NEW,
    BOOKING_VIEW_COMPLETED
} from '../../utils/config/constants';
import { store } from '../../store';
import { NotificationManager } from 'react-notifications';
import Axios from 'axios';
import { getCookies } from '../../utils/getToken';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
var isMounted = false;
class BlockedList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            loading: true,
            blockedList: [],
            toggleValue: true,
            toggleText: "Unblock",
            selectedIndex: null,
            isbuttonLoading: false,
            isbuttonBlockLoading: false
        };
    }
    getBlockedProviders = () => {
        var token = getCookies()
        Axios({
            method: 'get', //you can set what request you want to be
            url: `${SERVER_URL}/provider/my`,
            headers: {
                'x-auth-Token': token
            }
        }).then(resJson => {
            console.log("RESJSON::::", resJson.data.data)
            if (resJson.data.status == "OK") {
                this.setState({
                    blockedList: resJson.data.data,
                    loading: false,
                    toggleValue: resJson.data.data[0].has_been_blocked
                })
            } else {
                this.setState({
                    loading: false
                })
                NotificationManager.error("Success", resJson.data.message)

            }

        })
    }
    componentDidMount() {
        this.getBlockedProviders()
    }

    unblockProvider = (item, index) => {
        item.isSwitching = true;
        let updatedBlockedList = [...this.state.blockedList];
        updatedBlockedList[index] = item;
        this.setState({
            selectedIndex: index
        }, () => {
            console.log("Inside UnblockProvider")
            var token = getCookies()

            Axios({
                method: 'post', //you can set what request you want to be
                url: `${SERVER_URL}/user/unblock`,
                headers: {
                    'x-auth-Token': token
                },
                data: {
                    'provider_id': item.key
                }
            }).then(resJson => {
                console.log("RESJSON::::", resJson.data)
                if (resJson.data.status == "OK") {
                    item.has_been_blocked = !item.has_been_blocked;
                    item.isSwitching = false
                    let updatedBlockedList = [...this.state.blockedList];
                    updatedBlockedList[index] = item;
                    NotificationManager.success("Success", resJson.data.message)

                    this.setState({
                        toggleValue: false, blockedList: updatedBlockedList, selectedIndex: null,
                        isbuttonLoading: false

                    })
                } else {
                    NotificationManager.error("Success", resJson.data.message)

                    this.setState({
                        selectedIndex: null,
                        isbuttonLoading: false

                    })
                }

            })
        })

    }
    blockProvider = async (item, index) => {
        item.isSwitching = true;
        let updatedBlockedList = [...this.state.blockedList];
        updatedBlockedList[index] = item;
        this.setState({
            selectedIndex: index
        }, () => {
            console.log("Inside blockProvider")
            var token = getCookies()


            Axios({
                method: 'post', //you can set what request you want to be
                url: `${SERVER_URL}/user/block`,
                headers: {
                    'x-auth-Token': token
                },
                data: {
                    'provider_id': item.key
                }
            }).then(resJson => {
                console.log("RESJSON::::", resJson.data)
                if (resJson.data.status == "OK") {
                    item.has_been_blocked = !item.has_been_blocked;
                    item.isSwitching = false
                    let updatedBlockedList = [...this.state.blockedList];
                    updatedBlockedList[index] = item;

                    NotificationManager.success("Success", resJson.data.message)
                    this.setState({
                        toggleValue: true, blockedList: updatedBlockedList, selectedIndex: null,
                        isbuttonBlockLoading: false

                    })

                } else {
                    NotificationManager.error("Success", resJson.data.message)

                    this.setState({
                        selectedIndex: null,
                        isbuttonBlockLoading: false

                    })
                }

            })
        })


    }

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };


    render() {
        const { classes, match } = this.props;
        const { blockedList } = this.state;

        return (
            <div className="tz-2-com tz-2-main">

                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12 listing_div">
                            {blockedList.length > 0 ? (
                                <List
                                    className={classes.root + ' list-check-out'}
                                >
                                    {blockedList.map((item, index) => {
                                        return (
                                            <ListItem
                                                key={item.key}
                                                className={
                                                    classes.paper +
                                                    ' home-list-pop list-spac list-check-out-inn'
                                                }
                                            >
                                                <div className="col-md-12 col-lg-3  text-center col-xl-3 dashboard-booklist-img">
                                                    <ListItemAvatar>
                                                        <ProgressiveImage
                                                            delay={2000}
                                                            src={
                                                                item.proImage.small
                                                            }
                                                            placeholder="provider-image"
                                                        >
                                                            {(src, loading) =>
                                                                loading ? (
                                                                    this.renderPromoImage()
                                                                ) : (
                                                                        <img
                                                                          className='profile_img'
                                                                            src={
                                                                                src
                                                                            }
                                                                            alt="provider image"
                                                                        />
                                                                    )
                                                            }
                                                        </ProgressiveImage>
                                                    </ListItemAvatar>
                                                </div>
                                                <div className="col-md-12 col-lg-6 col-xl-6">
                                                    <ListItemText
                                                        className="home-list-pop-desc inn-list-pop-desc"
                                                        disableTypography={true}
                                                        primary={
                                                            <React.Fragment>
                                                                <h3>
                                                                    {
                                                                        item.name
                                                                    }
                                                                </h3>
                                                            </React.Fragment>
                                                        }
                                                        secondary={
                                                            <React.Fragment>
                                                                <h5>
                                                                    {
                                                                        item.phone
                                                                    }
                                                                </h5>


                                                            </React.Fragment>
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-12  col-lg-3 col-xl-3">

                                                    {!item.has_been_blocked ? item.isSwitching ? <CircularProgress /> : <Button
                                                        variant="contained"
                                                        size="medium"
                                                        color="primary"
                                                        className={
                                                            classes.margin
                                                        }
                                                        onClick={() => { this.blockProvider(item, index) }}
                                                    >
                                                        Block
                                    </Button> :
                                                        item.isSwitching ? <CircularProgress /> :
                                                            <Button
                                                                variant="contained"
                                                                size="medium"
                                                                color="primary"
                                                                className={
                                                                    classes.margin
                                                                }
                                                                onClick={() => { this.unblockProvider(item, index) }}
                                                            >
                                                                UnBlock
                                                    </Button>}
                                                </div>


                                            </ListItem>
                                        );
                                    })}


                                </List>
                            ) : (
                                    <div>
                                        <Paper>
                                            <p
                                                style={{
                                                    color: '#000',
                                                    padding: '10px'
                                                }}
                                            >
                                                No Provider found
                                            </p>
                                        </Paper>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

const mapStateToProps = ({ bookings }) => {
    return {
        bookingData: bookings.bookingData.bookingList,
        bookingDataCopy: bookings.bookingData,
        bookingLoader: bookings.bookingLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(withRouter(BlockedList)));



// WEBPACK FOOTER //
// ./src/components/Customer/BlockedList.jsx